export default __webpack_public_path__ + "static/media/ticketOrden.c709e26c.png";